/* eslint-disable react/jsx-one-expression-per-line */
import React, { useMemo } from 'react';

// Material
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';

// Constants
import IMAGES from 'constants/images';
import CONST_FLEET from 'constants/fleet';
import { CONST_LINES_OBJECT } from 'constants/lines';

// Helpers
import { Capitalize } from 'helpers/capitalize';

// Types
import { TripInterface } from 'store/ducks/trips/types';

// Styles
import useStyle from './tripNavigation.styles';

interface TripNavigationProps {
  tripData: TripInterface;
}

type Props = TripNavigationProps;

const TripNavigation: React.FC<Props> = ({ tripData }) => {
  const classes = useStyle();

  const carModel = useMemo(
    () =>
      CONST_FLEET.MODELS.find((m) => m.KEY === String(tripData?.Car?.model))
        ?.VALUE,
    [tripData],
  );

  const tripWay = useMemo(() => {
    let way: string = '';

    if (tripData && tripData.LineSection) {
      if (tripData.LineSection.way === CONST_LINES_OBJECT.WAYS.GO.KEY) {
        way = Capitalize(CONST_LINES_OBJECT.WAYS.GO.VALUE);
      } else {
        way = Capitalize(CONST_LINES_OBJECT.WAYS.BACK.VALUE);
      }
    }

    return way;
  }, [tripData]);

  if (!tripData || !tripData.id) return <></>;

  return (
    <div className={classes.root}>
      <Box display='flex' flexDirection='column' width='100%'>
        <Box flexGrow={0} p={2} display='flex' alignItems='center'>
          <Typography className={classes.title} variant='h6'>
            {tripData.title} {tripData.title && '•'}{' '}
            {tripData.LineSection?.Line.name}
          </Typography>
          <Box
            className={classes.square}
            style={{ background: tripData.LineSection?.Line.color }}
          />
        </Box>

        <Box flexGrow={1} p={2}>
          <Grid
            container
            justifyContent='space-between'
            alignItems='center'
            className={classes.carCard}>
            <Grid item lg={9} md={9} sm={9} xl={9} xs={9}>
              <Grid container direction='column'>
                <Box display='flex'>
                  <Typography color='primary' display='inline'>
                    prefixo:
                  </Typography>
                  <Typography display='inline'>
                    {tripData.Car?.prefix}
                  </Typography>
                </Box>

                <Box display='flex'>
                  <Typography color='primary' display='inline'>
                    placa:
                  </Typography>
                  <Typography display='inline'>
                    {tripData.Car?.license}
                  </Typography>
                </Box>

                <Box display='flex'>
                  <Typography color='primary' display='inline'>
                    modelo:
                  </Typography>
                  <Typography display='inline'>{carModel}</Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid item xs={3} className={classes.carCardImage}>
              <CardMedia component='img' src={IMAGES.BOX_BUS} />
            </Grid>
          </Grid>

          <Grid container direction='column' className={classes.margins}>
            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                motorista:&nbsp;
              </Typography>
              <Typography display='inline'>
                {tripData.TransportEmployee?.name}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                garagem:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                percurso:&nbsp;
              </Typography>
              <Typography display='inline'>
                {tripData.LineSection?.Line.name}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                sentido:&nbsp;
              </Typography>
              <Typography display='inline'>{tripWay}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                velocidade:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                ignicão:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>
          </Grid>

          <Grid container direction='column' className={classes.margins}>
            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                tabela:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                viagem:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                horário inicial programado:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                horário final programado:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>
          </Grid>

          <Grid container direction='column' className={classes.margins}>
            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                última parada:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                entrada:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                saída:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>
          </Grid>

          <Grid container direction='column' className={classes.margins}>
            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                última parada intermediária:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                saída programada:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                saída realizada:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>

            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                diferença de tempo:&nbsp;
              </Typography>
              <Typography display='inline' />
            </Grid>
          </Grid>

          {/*           <Grid container direction='column' className={classes.margins}>
            <Grid item xs={12}>
              <Typography color='primary' display='inline'>
                última coordenada:&nbsp;
              </Typography>
              <Box display='flex'>
                <Typography display='inline'>
                  latitude&nbsp;&bull;&nbsp;
                </Typography>
                <Typography display='inline'>{carData.lat}</Typography>
              </Box>

              <Box display='flex'>
                <Typography display='inline'>
                  longitude&nbsp;&bull;&nbsp;
                </Typography>
                <Typography display='inline'>{carData.lng}</Typography>
              </Box>
            </Grid>
          </Grid> */}
        </Box>
      </Box>
    </div>
  );
};

export { TripNavigation };
export default TripNavigation;
